import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Quote } from "lucide-react";
import { Reveal } from "../lib/motion";
import { TESTIMONIALS } from "../data";

export const Testimonials = () => {
  const [active, setActive] = useState(0);
  const t = TESTIMONIALS[active];

  return (
    <section
      className="relative overflow-hidden border-t border-black/10 py-28 md:py-36"
      data-testid="testimonials-section"
    >
      <div className="container-vx">
        <Reveal>
          <span className="label-mono">/ In their words</span>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 items-center gap-12 lg:grid-cols-12 lg:gap-20">
          <div className="lg:col-span-8">
            <AnimatePresence mode="wait">
              <motion.blockquote
                key={active}
                initial={{ opacity: 0, y: 24 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -16 }}
                transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
              >
                <Quote className="mb-8 h-10 w-10 text-[var(--accent)]/70" strokeWidth={1} />
                <p className="font-sans text-3xl font-light leading-snug tracking-tight md:text-4xl lg:text-[2.75rem] lg:leading-[1.15]">
                  "{t.quote}"
                </p>
                <footer className="mt-10 flex items-center gap-4">
                  <div className="spotlight-img h-14 w-14 overflow-hidden rounded-full border border-black/10">
                    <img src={t.img} alt={t.name} className="h-full w-full object-cover" />
                  </div>
                  <div>
                    <div className="font-sans font-medium">{t.name}</div>
                    <div className="font-body text-sm text-neutral-500">{t.role}</div>
                  </div>
                </footer>
              </motion.blockquote>
            </AnimatePresence>

            <div className="mt-12 flex gap-3">
              {TESTIMONIALS.map((_, i) => (
                <button
                  key={i}
                  onClick={() => setActive(i)}
                  data-testid={`testimonial-dot-${i}`}
                  aria-label={`Testimonial ${i + 1}`}
                  className={`h-1.5 rounded-full transition-all duration-400 ${
                    active === i ? "w-10 bg-[var(--accent)]" : "w-4 bg-black/15 hover:bg-black/30"
                  }`}
                />
              ))}
            </div>
          </div>

          <div className="hidden lg:col-span-4 lg:block">
            <Reveal delay={0.1}>
              <div className="rounded-3xl border border-black/10 bg-white p-8 card-shadow">
                <div className="font-sans text-5xl font-light tracking-tight">4.9/5</div>
                <p className="mt-2 font-body text-sm text-neutral-500">
                  Average partner satisfaction across active engagements.
                </p>
                <div className="mt-8 h-px w-full bg-black/10" />
                <div className="mt-8 font-sans text-5xl font-light tracking-tight">100%</div>
                <p className="mt-2 font-body text-sm text-neutral-500">
                  Of pilots that reached production in the last 24 months.
                </p>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};
